import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-regular-manual-rostering',
  templateUrl: './regular-manual-rostering.component.html',
  styleUrls: ['./regular-manual-rostering.component.css']
})
export class RegularManualRosteringComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
